import _ from "lodash";
import { formatDate, RenderCellExpand } from "../../common";

// Status dropdown values for the procurement approval column.
const PROC_STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "Accepted", label: "Accepted" },
  { value: "Rejected", label: "Rejected" },
];

const dateFormatter = (params) =>
  params.value !== "pending" ? formatDate(params.value) : params.value;

/**
 * Column config for the All Requests table. Each entry drives a DataGrid column
 * with an embedded per-column server-side search control (see
 * createSearchColumns / ColumnHeaderSearch). `search` is the control kind; each
 * `field` must match a key the backend whitelists in REQUEST_SEARCHABLE_FIELDS
 * (requestListShared). Columns without `search` (Lead Time, No. of Items) render
 * a plain header. Mirrors the previous dynamically-generated column set.
 */
export const allRequestsColumnConfig = [
  { field: "sampleRequestID", minWidth: 220, search: "text" },
  {
    field: "department",
    minWidth: 200,
    search: "text",
    renderCell: RenderCellExpand,
  },
  {
    field: "organization",
    minWidth: 200,
    search: "text",
    renderCell: RenderCellExpand,
  },
  { field: "email", minWidth: 220, search: "text", renderCell: RenderCellExpand },
  {
    field: "purpose",
    minWidth: 200,
    search: "text",
    renderCell: RenderCellExpand,
  },
  {
    field: "endUserLocation",
    minWidth: 200,
    search: "text",
    renderCell: RenderCellExpand,
  },
  {
    field: "businessUnit",
    minWidth: 200,
    search: "text",
    renderCell: RenderCellExpand,
  },
  {
    field: "executiveChefEmail",
    minWidth: 220,
    search: "text",
    renderCell: RenderCellExpand,
  },
  {
    field: "HODDepartment",
    minWidth: 200,
    search: "text",
    renderCell: RenderCellExpand,
  },
  {
    field: "needByDate",
    minWidth: 260,
    search: "date",
    type: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
  { field: "leadTime", headerName: "Lead Time", minWidth: 120, type: "number" },
  {
    field: "status",
    minWidth: 200,
    search: "status",
    csvFormat: "startCase",
    statusOptions: PROC_STATUS_OPTIONS,
    valueGetter: (params) =>
      params.row.procurementApproval &&
      _.startCase(params.row.procurementApproval.status),
  },
  {
    field: "processedBy",
    minWidth: 200,
    search: "text",
    csvFormat: "naText",
    valueGetter: (params) =>
      params.row.procurementApproval.processedBy
        ? params.row.procurementApproval.processedBy
        : "N/A",
  },
  {
    field: "items",
    headerName: "No. of Items",
    minWidth: 130,
    type: "number",
    valueGetter: (params) => (params.value ? params.value.length : 0),
  },
  {
    field: "date",
    minWidth: 260,
    search: "date",
    type: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
  {
    field: "dateModified",
    minWidth: 260,
    search: "date",
    type: "date",
    csvFormat: "date",
    valueFormatter: dateFormatter,
  },
];
